import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelayLocNames =
	| 'SPSettingsScoreReportDelayTabTitle'
	| 'SPSettingsScoreReportDelayPageDescription';

export const spSettingsScoreReportDelayLocs: LocDefs<SPSettingsScoreReportDelayLocNames> = {
	SPSettingsScoreReportDelayTabTitle: {
		defaultValue: 'Score Report Delay',
		description: 'Tab title for the score report delay settings.',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayPageDescription: {
		defaultValue:
			'<p>This page displays the default delay before an exam score report can be seen by the candidate. The top section displays the system wide default. The next section displays sections that have delays different than the system default. Users with appropriate rights may modify one or more of these settings. If the user sets the delay equal to the current default, the setting will be removed from the database. This setting will be treated as if it was reset to the default.</p>',
		description: 'Page description for the score report delay settings.',
		displayPath: `${pathStart}Page Description`,
		displayType: 'Content',
		shared: false,
		htmlAllowed: true,
		feature: HubFeature.ExamScoreReportsBatch,
		portal: 'SP',
	},
};

export type SPSettingsScoreReportDelayLocType = LocMap<SPSettingsScoreReportDelayLocNames>;
